import { render, staticRenderFns } from "./popover_component.vue?vue&type=template&id=cbae1eba&scoped=true&"
import script from "./popover_component.vue?vue&type=script&lang=js&"
export * from "./popover_component.vue?vue&type=script&lang=js&"
import style0 from "./popover_component.vue?vue&type=style&index=0&id=cbae1eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbae1eba",
  null
  
)

export default component.exports